import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85d7ae40"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Options")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

import Modal from "components/Modal.vue";
import projInfo from "data/projInfo.json";
import rawThemes from "data/themes";
import { jsx } from "features/feature";
import player from "game/player";
import settings, { settingFields } from "game/settings";
import { camelToTitle } from "util/common";
import { coerceComponent, render } from "util/vue";
import { computed, ref, toRefs } from "vue";
import Select from "./fields/Select.vue";
import Toggle from "./fields/Toggle.vue";
import Tooltip from "features/tooltips/Tooltip.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const isOpen = ref(false);

expose({
    open() {
        isOpen.value = true;
    }
});

const themes = Object.keys(rawThemes).map(theme => ({
    label: camelToTitle(theme),
    value: theme
}));

const settingFieldsComponent = computed(() => {
    return coerceComponent(jsx(() => <>{settingFields.map(render)}</>));
});

const { showTPS, theme, unthrottled } = toRefs(settings);
const { autosave, offlineProd } = toRefs(player);
const isPaused = computed({
    get() {
        return player.devSpeed === 0;
    },
    set(value: boolean) {
        player.devSpeed = value ? 0 : null;
    }
});

const offlineProdTitle = jsx(() => (
    <span>
        Offline Production<Tooltip display="Save-specific">*</Tooltip>
    </span>
));
const autosaveTitle = jsx(() => (
    <span>
        Autosave<Tooltip display="Save-specific">*</Tooltip>
    </span>
));
const isPausedTitle = jsx(() => (
    <span>
        Pause game<Tooltip display="Save-specific">*</Tooltip>
    </span>
));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isOpen).value = $event))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode(Select, {
        title: "Theme",
        options: _unref(themes),
        modelValue: _unref(theme),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(theme) ? (theme).value = $event : null))
      }, null, 8, ["options", "modelValue"]),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(settingFieldsComponent)))),
      _createVNode(Toggle, {
        title: "Show TPS",
        modelValue: _unref(showTPS),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(showTPS) ? (showTPS).value = $event : null))
      }, null, 8, ["modelValue"]),
      _hoisted_2,
      _createVNode(Toggle, {
        title: "Unthrottled",
        modelValue: _unref(unthrottled),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(unthrottled) ? (unthrottled).value = $event : null))
      }, null, 8, ["modelValue"]),
      _createVNode(Toggle, {
        title: _unref(offlineProdTitle),
        modelValue: _unref(offlineProd),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(offlineProd) ? (offlineProd).value = $event : null))
      }, null, 8, ["title", "modelValue"]),
      _createVNode(Toggle, {
        title: _unref(autosaveTitle),
        modelValue: _unref(autosave),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(autosave) ? (autosave).value = $event : null))
      }, null, 8, ["title", "modelValue"]),
      (_unref(projInfo).enablePausing)
        ? (_openBlock(), _createBlock(Toggle, {
            key: 0,
            title: _unref(isPausedTitle),
            modelValue: _unref(isPaused),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(isPaused) ? (isPaused).value = $event : null))
          }, null, 8, ["title", "modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})